import { COUNTRY_CODES } from "./countries";
import { configuracionDePais } from "../utils/configuracionDePais";

const IDENTITY_DOCUMENTS = {
  [COUNTRY_CODES.ECUADOR]: {
    cedula: {
      label: "Cédula",
      value: "Cedula",
      aliases: ["ID"], // BC (SaaS Ecuador) devuelve "ID" en Tipo_Documento_SrI para clientes con cédula (verificado contra ListaClientes)
      regex: /^\d{10}$/,
      message: "La cédula debe tener exactamente 10 dígitos numéricos",
    },
    ruc: {
      label: "RUC",
      value: "RUC",
      aliases: ["VAT"], // BC (SaaS Ecuador) devuelve "VAT" en Tipo_Documento_SrI para clientes con RUC (verificado contra ListaClientes)
      regex: /^\d{13}$/,
      message: "El RUC debe tener exactamente 13 dígitos numéricos",
    },
    pasaporte: {
      label: "Pasaporte",
      value: "Pasaporte",
      aliases: ["Passport"], // BC (SaaS Ecuador) devuelve "Passport" en Tipo_Documento_SrI para clientes con pasaporte (verificado contra ListaClientes)
      regex: /^[A-Za-z0-9]{6,20}$/,
      message: "El pasaporte debe ser alfanumérico entre 6 y 20 caracteres",
    },
  },
  [COUNTRY_CODES.PARAGUAY]: {
    cedula: {
      label: "Cédula",
      value: "Cedula",
      regex: /^[A-Za-z0-9-]{6,20}$/,
      message: "El documento debe tener entre 6 y 20 cáracteres",
    },
    ruc: {
      label: "RUC",
      value: "RUC",
      regex: /^[A-Za-z0-9-]{8,20}$/,
      message: "El documento debe tener entre 8 y 20 caracteres",
    },
    pasaporte: {
      label: "Pasaporte",
      value: "Pasaporte",
      regex: /^[A-Za-z0-9-]{9,20}$/,
      message: "El documento debe tener entre 9 y 20 cáracteres",
    },
  },
  [COUNTRY_CODES.ELSALVADOR]: {
    nit: {
      label: "NIT",
      value: "NIT",
      regex: /^\d{4}-?\d{6}-?\d{3}-?\d$/,
      message: "El NIT debe tener 14 dígitos (con o sin guiones)",
    },
    dui: {
      label: "DUI",
      value: "DUI",
      regex: /^\d{8}-?\d$/,
      message: "El DUI debe tener 9 dígitos (con o sin guion)",
    },
    otros: {
      label: "Otros",
      value: "Otros",
      regex: /^.{1,20}$/,
      message: "Otros admite entre 1 y 20 caracteres",
    },
  },
  [COUNTRY_CODES.HONDURAS]: {
    rtn: {
      label: "RTN",
      value: "RTN",
      regex: /^\d{14}$/,
      message: "El RTN debe tener exactamente 14 dígitos numéricos",
    },
  },
  [COUNTRY_CODES.COSTARICA]: {
    // Costa Rica no usa el tipo del SRI ecuatoriano sino "Tax Identification Type", un enum
    // ESTANDAR de Business Central (Customer 14020, enum 253) que su migracion extiende con
    // DIMEX, NITE, Extranjero No Domiciliado y No Contribuyente, y que su facturacion
    // electronica ya usa para el XML de Hacienda.
    //
    // El `value` es el NOMBRE del valor del enum, que es lo que BC acepta al escribir. Al leer,
    // BC devuelve el CAPTION -- medido: Ecuador declara OptionCaption "VAT,ID,Passport" y eso es
    // exactamente lo que llega aqui. Para los cuatro tipos que anade Costa Rica el caption
    // coincide con el nombre, asi que no hacen falta alias; para los dos de fabrica el caption
    // esta en ingles y PUEDE venir traducido por el paquete de idioma de Microsoft, asi que las
    // formas en espanol van como alias hasta que se mida contra el ambiente. Un alias de mas no
    // rompe nada; que falte, si.
    //
    // Los formatos son los del catalogo de Hacienda: cedula fisica 9 digitos sin cero inicial,
    // juridica 10 igual, DIMEX 11 o 12, NITE 10, y alfanumerico hasta 20 para los dos ultimos.
    //
    // OJO al aplicarlos: medido el 31/08/2026 sobre los 11.805 clientes de Costa Rica TEST,
    // **516 (4,4%) no pasan la regla de su propio tipo** -- 447 personas fisicas con el numero
    // escrito a 10 digitos con un cero delante, 56 juridicas de 9 o 12 digitos, 13 DIMEX con
    // letras. No se revalida nada existente: la regla solo actua al guardar, asi que esos 516
    // solo se bloquean si alguien los edita, y entonces hay que corregir el numero.
    //
    // Antes de esta entrada Costa Rica caia al fallback de Ecuador, y el ticket imprimia siempre
    // "Cedula" sin dar ningun error.
    // La jurídica son 10 CARACTERES, no 10 dígitos, y sí puede empezar por cero.
    //
    // Literal de los Anexos v4.4 --pág. 20 para el emisor y pág. 23 para el
    // receptor, revisión del 22/04/2026--: «La "cédula de personas Jurídicas"
    // debe contener 10 caracteres y sin guiones». La restricción «sin cero al
    // inicio» está escrita, pero sólo para la cédula física y el DIMEX; para la
    // jurídica no aparece. Y la bitácora del documento dice por qué cambió:
    // «en concordancia con las disposiciones del Registro Nacional».
    //
    // Importa desde que el terminal **bloquea la venta** con esta regla: medido
    // el 12/09/2026 sobre las 1.244 personas jurídicas con número de Costa Rica
    // producción, la regla vieja dejaba fuera a 14 clientes legítimos con cédula
    // de diez caracteres empezada por cero --`0205170285` y similares--, y cada
    // uno era una factura que no se podía emitir.
    //
    // Las 41 que siguen sin pasar tienen 9 o 12 caracteres: ésas no son cédulas
    // jurídicas, y ahí el aviso es correcto.
    personaJuridica: {
      label: "Persona jurídica",
      value: "Legal Entity",
      aliases: ["Persona jurídica", "Persona Jurídica"],
      regex: /^[A-Za-z0-9]{10}$/,
      message: "La cédula jurídica debe tener 10 caracteres, sin guiones ni espacios",
    },
    personaFisica: {
      label: "Persona física",
      value: "Natural Person",
      aliases: ["Persona física", "Persona Física"],
      regex: /^[1-9]\d{8}$/,
      message: "La cédula física debe tener 9 dígitos y no empezar por cero",
    },
    dimex: {
      label: "DIMEX",
      value: "DIMEX",
      regex: /^\d{11,12}$/,
      message: "El DIMEX debe tener 11 o 12 dígitos",
    },
    nite: {
      label: "NITE",
      value: "NITE",
      regex: /^\d{10}$/,
      message: "El NITE debe tener exactamente 10 dígitos",
    },
    extranjeroNoDomiciliado: {
      label: "Extranjero no domiciliado",
      value: "Extranjero No Domiciliado",
      regex: /^[A-Za-z0-9-]{1,20}$/,
      message: "Admite hasta 20 caracteres alfanuméricos",
    },
    noContribuyente: {
      label: "No contribuyente",
      value: "No Contribuyente",
      regex: /^[A-Za-z0-9-]{1,20}$/,
      message: "Admite hasta 20 caracteres alfanuméricos",
    },
  },
  [COUNTRY_CODES.PERU]: {
    ruc: {
      label: "RUC",
      value: "6",
      regex: /^\d{11}$/,
      message: "El RUC debe tener exactamente 11 dígitos numéricos",
    },
    dni: {
      label: "DNI",
      value: "1",
      regex: /^\d{8}$/,
      message: "El DNI debe tener exactamente 8 dígitos numéricos",
    },
    carnet: {
      label: "Carnet de extranjería",
      value: "4",
      regex: /^\d{9}$/,
      message: "El carnet de extranjería debe tener exactamente 9 dígitos numéricos",
    },
    otros: {
      label: "Otros",
      value: "0",
      regex: /^[A-Za-z0-9]{1,30}$/,
      message: "Otros admite hasta 30 caracteres alfanuméricos",
    },
  },
};

export const findIdentityDocument = (country, selectedType) => {
  const docs = getIdentityDocument(country);

  return Object.values(docs).find(
    (doc) => doc.value === selectedType || doc.aliases?.includes(selectedType)
  );
};

export const getIdentityDocument = (country) => {
  return configuracionDePais(IDENTITY_DOCUMENTS, country, "documentos de identidad");
};

/**
 * Bajo qué nombre viaja el tipo de documento en cada país, y en cada origen.
 *
 * No es lo mismo el cliente que la factura, y por eso hay dos claves: en Costa
 * Rica el cliente lo publica como `Tax_Identification_Type` --el campo estándar
 * de Business Central-- y la factura registrada como
 * `EXCCRITaxIdentificationType`, que es el de su migración. Confundirlos deja el
 * dato vacío sin dar ningún error.
 *
 * Vive aparte de IDENTITY_DOCUMENTS a propósito: ese registro se recorre con
 * `Object.values()` para buscar documentos, y una clave que no fuera un
 * documento se colaría en esas búsquedas.
 */
const PROPIEDAD_DEL_TIPO = {
  [COUNTRY_CODES.COSTARICA]: {
    cliente: "Tax_Identification_Type",
    factura: "EXCCRITaxIdentificationType",
  },
};

// Panamá publica el tipo por los mismos dos campos: no es cosa del país sino de
// la extensión, y comparte ambiente y migración con Costa Rica. El nombre
// `EXCCRI...` es el que le puso su migración; que lleve las siglas de Costa Rica
// no lo hace exclusivo suyo.
PROPIEDAD_DEL_TIPO[COUNTRY_CODES.PANAMA] = PROPIEDAD_DEL_TIPO[COUNTRY_CODES.COSTARICA];

// Los dos tipos de documento de Panamá.
//
// Sólo dos, y son los dos de fábrica del enum de Business Central: ninguno de
// los cuatro que añadió Costa Rica --DIMEX, NITE y los dos de extranjería-- se
// usa allá. Medido el 09/09/2026 sobre las 1.837 fichas de clientes de Panamá:
// 1.157 personas jurídicas (63%) y 680 físicas (37%), y ninguna otra cosa.
//
// **Sin comprobación de formato, y es deliberado.** Los números reales van desde
// `8-959-1349` hasta `8-MT-1-14427`, `N-15-369` o `3-101-145880-22`: sólo el
// 39,5% encaja en la cédula clásica de provincia-tomo-asiento. Una expresión
// regular estricta bloquearía a seis de cada diez en cuanto alguien edite su
// ficha, y eso es peor que no comprobar nada. `dynamicFormFieldsUtils` ya
// contempla un tipo sin `regex` y lo deja pasar.
//
// Los alias son los mismos que en Costa Rica y por la misma razón: al escribir,
// BC acepta el NOMBRE del valor del enum; al leer devuelve el CAPTION, que para
// estos dos está en inglés y puede venir traducido por el paquete de idioma.
IDENTITY_DOCUMENTS[COUNTRY_CODES.PANAMA] = {
  personaJuridica: {
    label: "Persona jurídica",
    value: "Legal Entity",
    aliases: ["Persona jurídica", "Persona Jurídica"],
  },
  personaFisica: {
    label: "Persona física",
    value: "Natural Person",
    aliases: ["Persona física", "Persona Física"],
  },
};

const PROPIEDAD_POR_DEFECTO = {
  cliente: "Tipo_Documento_SrI",
  factura: "Tipo_Documento_SrI",
};

/** Cómo se llama la propiedad del tipo de documento para este país y origen. */
export const propiedadDelTipoDeDocumento = (country, origen = "cliente") =>
  (PROPIEDAD_DEL_TIPO[country] ?? PROPIEDAD_POR_DEFECTO)[origen] ?? PROPIEDAD_POR_DEFECTO[origen];

/**
 * El tipo de documento de un registro que viene de Business Central, ya
 * normalizado al `value` del catálogo.
 *
 * Sustituye a las dos copias de `resolveDocumentType` que vivían en
 * clientSyncService y en syncUtils **con la firma invertida** --una
 * `(pais, valor)` y la otra `(valor, pais)`--: dos funciones con el mismo
 * nombre, el mismo cuerpo y los argumentos al revés funcionan hasta que alguien
 * copia una llamada de un archivo al otro.
 *
 * Se le pasa el objeto entero, no el valor, porque la propiedad de la que hay
 * que leerlo depende del país. Los nombres de respaldo cubren a los países que
 * no declaran el suyo y a las dos formas en que la factura lo ha traído
 * históricamente.
 *
 * @param {object} desdeBC  El registro tal como lo devuelve Business Central.
 * @param {string} country  Código del país activo.
 * @param {"cliente"|"factura"} [origen]
 */
export const resolverTipoDeDocumento = (desdeBC, country, origen = "cliente") => {
  if (!desdeBC) return "";
  const crudo =
    desdeBC[propiedadDelTipoDeDocumento(country, origen)] ??
    desdeBC.Tipo_Documento_SrI ??
    desdeBC.Tipo_Documento;

  // Perú no publica "Tipo_Documento_SrI" al traer clientes -- sólo
  // "Documento SUNAT" (SUNAT_Document), con el mismo código ("1" DNI, "4"
  // Carnet, "6" RUC...: ver DOCUMENTOS_SUNAT en constants/peruClientCatalogs.js).
  // Sin este respaldo el cliente queda sin tipo y la Boleta/Factura de
  // InvoiceHeader.js no se auto-selecciona.
  const conRespaldo =
    !crudo && origen === "cliente" && country === COUNTRY_CODES.PERU
      ? desdeBC.SUNAT_Document
      : crudo;

  if (!conRespaldo) return conRespaldo ?? "";
  if (!country) return conRespaldo;
  return findIdentityDocument(country, conRespaldo)?.value || conRespaldo;
};
